"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isDesignAllowedForPages;
const constants_1 = require("./constants");
const newrelic_1 = require("../split.io/newrelic");
const getRangeArray = rangeString => {
  return (rangeString === null || rangeString === void 0 ? void 0 : rangeString.split('...').map(n => n === constants_1.LAST ? Infinity : n === constants_1.FIRST ? -Infinity : parseFloat(n))) || [];
};
// Checks if design is legit according to a defined existing page-range (controlAllowedPages)
function isDesignAllowedForPages(design, controlAllowedPages) {
  if (design.allowedPages === constants_1.ALL || design.allowedPages === controlAllowedPages) {
    return true;
  }
  // "15...15"
  const newRange = getRangeArray(design.allowedPages);
  const controlRange = getRangeArray(controlAllowedPages);
  if (!newRange.length || !controlRange.length) {
    if ((0, newrelic_1.canNR)()) {
      window.newrelic.addPageAction(`isDesignAllowedForPages: Invalid allowedPages (new: ${design.allowedPages} in design ${design.designId} or controlAllowedPages: ${controlAllowedPages})`);
    }
    return false;
  }
  // The new design must include the old design's range. Ex: 3...last is a suitable replacement for 4...4 because 4...4(old) lands in between 3...last(new). 
  return newRange[0] <= controlRange[0] && newRange[1] >= controlRange[1];
}